import { BrandKey } from '@prismamedia/one-brandkey';
import { GetAffilizzDesignsQuery_query_searchAffiliationDesign_searchAffilizzDesignResult } from '../../../../__generated__/queries-web';

export const loadScript = (
  src: string,
  success?: () => void,
  error?: () => void,
) => {
  const scriptDom = document.getElementById(src);
  if (scriptDom) {
    return;
  }

  const script = document.createElement('script');
  script.setAttribute('src', src);
  script.setAttribute('id', src);

  if (success) {
    script.addEventListener('load', success);
  }

  if (error) {
    script.addEventListener('error', error);
  }

  document.body.appendChild(script);

  return () => {
    if (success) {
      script.removeEventListener('load', success);
    }
    if (error) {
      script.removeEventListener('error', error);
    }
  };
};

export const getModelId = (
  brandKey: BrandKey,
  models: GetAffilizzDesignsQuery_query_searchAffiliationDesign_searchAffilizzDesignResult[],
) => {
  const result = models.find(
    (m) => m.name.toUpperCase() === brandKey.toUpperCase(),
  );
  if (result) {
    return result?.id;
  }

  return config.AFFILIZZ_MODEL_IDS['DEFAULT'];
};
